import { makeStyles } from '@material-ui/core/styles';

const smsPolicyStyles = makeStyles((theme) => ({
	root: {
		color: theme.palette.navy.main,
		fontWeight: 300,
		lineHeight: 1.7,
		'& a': {
			color: theme.palette.primary.main,
			fontWeight: 600,
			textDecoration: 'none',
			'&:hover': {
				textDecoration: 'underline',
			},
		},
		'& address': {
			fontStyle: 'normal',
			lineHeight: 1.8,
		},
	},
	effectiveDate: {
		display: 'flex',
		alignItems: 'flex-start',
		background: '#f0f4f8',
		borderRadius: 12,
		padding: '1.5rem 1.75rem',
		marginBottom: '2.75rem',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			alignItems: 'center',
			textAlign: 'center',
		},
	},
	effectiveIcon: {
		flexShrink: 0,
		width: 52,
		height: 52,
		borderRadius: '50%',
		background: theme.palette.primary.main,
		color: '#fff',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginRight: '1.25rem',
		[theme.breakpoints.down('xs')]: {
			marginRight: 0,
			marginBottom: '1rem',
		},
		'& svg': {
			fontSize: 26,
		},
	},
	effectiveTitle: {
		margin: 0,
		fontWeight: 900,
		fontSize: '1.05rem',
		color: theme.palette.navy.darkest,
	},
	effectiveBody: {
		margin: '0.5rem 0 0',
		color: theme.palette.navy.main,
		fontSize: '0.95rem',
	},
	section: {
		marginBottom: '2.75rem',
	},
	sectionHeader: {
		display: 'flex',
		alignItems: 'flex-start',
		marginBottom: '1.25rem',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			alignItems: 'flex-start',
		},
	},
	sectionIcon: {
		flexShrink: 0,
		width: 64,
		height: 64,
		borderRadius: '50%',
		background: 'rgba(83, 144, 205, 0.15)',
		color: theme.palette.primary.main,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginRight: '1.25rem',
		[theme.breakpoints.down('xs')]: {
			marginRight: 0,
			marginBottom: '1rem',
		},
		'& svg': {
			fontSize: 32,
		},
	},
	sectionTitle: {
		margin: 0,
		fontSize: '1.5rem',
		fontWeight: 900,
		color: theme.palette.navy.darkest,
		lineHeight: 1.3,
	},
	accent: {
		display: 'block',
		width: 48,
		height: 3,
		background: theme.palette.primary.main,
		borderRadius: 2,
		marginTop: '0.65rem',
	},
	body: {
		margin: '0 0 1rem',
		fontSize: '1rem',
	},
	checkList: {
		listStyle: 'none',
		margin: '1.25rem 0',
		padding: 0,
	},
	checkItem: {
		display: 'flex',
		alignItems: 'flex-start',
		marginBottom: '0.85rem',
		fontSize: '1rem',
		lineHeight: 1.5,
	},
	checkIcon: {
		flexShrink: 0,
		marginTop: 2,
		marginRight: '0.75rem',
		color: theme.palette.primary.main,
		fontSize: 22,
	},
	infoBanner: {
		display: 'flex',
		alignItems: 'flex-start',
		background: 'rgba(83, 144, 205, 0.12)',
		borderRadius: 8,
		padding: '1rem 1.25rem',
		marginTop: '1.5rem',
		color: theme.palette.navy.darker,
		fontWeight: 600,
		fontSize: '0.95rem',
		lineHeight: 1.5,
	},
	infoIcon: {
		flexShrink: 0,
		color: theme.palette.primary.main,
		marginTop: 1,
		marginRight: '0.85rem',
	},
	splitRow: {
		display: 'flex',
		flexDirection: 'column',
		background: '#f0f4f8',
		borderRadius: 12,
		overflow: 'hidden',
		marginBottom: '2.75rem',
		[theme.breakpoints.up('md')]: {
			flexDirection: 'row',
		},
	},
	splitCol: {
		flex: 1,
		padding: '1.75rem',
		[theme.breakpoints.up('md')]: {
			padding: '2rem 2.25rem',
		},
	},
	splitDivider: {
		width: '100%',
		height: 1,
		background: 'rgba(52, 59, 77, 0.12)',
		[theme.breakpoints.up('md')]: {
			width: 1,
			height: 'auto',
			alignSelf: 'stretch',
		},
	},
	splitIcon: {
		width: 44,
		height: 44,
		borderRadius: '50%',
		background: theme.palette.primary.main,
		color: '#fff',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: '1rem',
		'& svg': {
			fontSize: 22,
		},
	},
	splitTitle: {
		margin: 0,
		fontSize: '1.25rem',
		fontWeight: 900,
		color: theme.palette.navy.darkest,
	},
	legalSection: {
		marginBottom: '2.25rem',
		paddingTop: '0.25rem',
		'& h2': {
			margin: '0 0 0.85rem',
			fontSize: '1.35rem',
			fontWeight: 900,
			color: theme.palette.navy.darkest,
		},
		'& p': {
			margin: '0 0 0.85rem',
		},
		'& ul': {
			margin: '0.5rem 0 1rem',
			paddingLeft: '1.25rem',
		},
		'& li': {
			marginBottom: '0.45rem',
		},
	},
	keyword: {
		display: 'inline-block',
		background: theme.palette.primary.main,
		color: '#fff',
		fontWeight: 900,
		fontSize: '0.8rem',
		letterSpacing: '0.04em',
		padding: '0.15rem 0.55rem',
		borderRadius: 4,
		margin: '0 0.2rem',
	},
	formCard: {
		background: '#fff',
		border: '1px solid rgba(52, 59, 77, 0.14)',
		borderRadius: 12,
		padding: '1.75rem',
		margin: '1.5rem 0',
		boxShadow: '0 8px 24px rgba(29, 33, 43, 0.06)',
	},
	formTitle: {
		margin: '0 0 0.35rem',
		fontSize: '1.25rem',
		fontWeight: 900,
		color: theme.palette.navy.darkest,
	},
	formLabel: {
		display: 'block',
		fontWeight: 600,
		fontSize: '0.9rem',
		color: theme.palette.navy.darkest,
		margin: '1.15rem 0 0.4rem',
	},
	formInput: {
		display: 'block',
		width: '100%',
		boxSizing: 'border-box',
		padding: '0.7rem 0.85rem',
		border: '1px solid rgba(52, 59, 77, 0.22)',
		borderRadius: 6,
		fontSize: '1rem',
		fontFamily: 'inherit',
		background: '#fff',
		color: theme.palette.navy.main,
	},
	consentRow: {
		display: 'flex',
		alignItems: 'flex-start',
		marginTop: '1.25rem',
	},
	consentBox: {
		flexShrink: 0,
		width: 18,
		height: 18,
		marginTop: 3,
		marginRight: '0.75rem',
	},
	consentText: {
		margin: 0,
		fontSize: '0.95rem',
		lineHeight: 1.6,
		color: theme.palette.navy.main,
	},
	formButton: {
		display: 'inline-block',
		marginTop: '1.35rem',
		background: theme.palette.primary.main,
		color: '#fff',
		border: 0,
		borderRadius: 6,
		padding: '0.7rem 1.25rem',
		fontWeight: 900,
		fontSize: '0.95rem',
		fontFamily: 'inherit',
		cursor: 'default',
	},
	formShot: {
		display: 'block',
		width: '100%',
		height: 'auto',
		borderRadius: 12,
		border: '1px solid rgba(52, 59, 77, 0.15)',
		margin: '1.25rem 0',
	},
}));

export default smsPolicyStyles;
